import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 应用程序顶部导航栏UI组件
 * 提供灵活的三栏式插槽布局（左、中、右），不包含路由逻辑
 */
export const AppHeader = ({ slotLeft, slotCenter, slotRight, className = '', }) => {
    return (_jsx("header", { className: `bg-static-eggshell text-interactive-emerald-flash shadow-lg sticky top-0 z-50 ${className}`, children: _jsxs("div", { className: "w-full px-[5%] py-4 flex items-center", children: [_jsx("div", { className: "w-1/3 overflow-hidden whitespace-nowrap text-ellipsis", children: slotLeft }), _jsx("div", { className: "w-1/3 overflow-hidden whitespace-nowrap text-ellipsis flex justify-center", children: slotCenter }), _jsx("div", { className: "w-1/3 overflow-hidden whitespace-nowrap text-ellipsis flex justify-end", children: slotRight })] }) }));
};
// 添加默认导出以兼容旧代码
export default AppHeader;
//# sourceMappingURL=AppHeader.js.map